import { useState, useEffect } from "react";
import { Toaster as Sonner, toast } from "sonner";

function useAppTheme() {
  const [theme, setTheme] = useState(() =>
    document.documentElement.classList.contains("dark") ? "dark" : "light"
  );
  useEffect(() => {
    const obs = new MutationObserver(() => {
      setTheme(document.documentElement.classList.contains("dark") ? "dark" : "light");
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return theme;
}

const Toaster = (props) => {
  const theme = useAppTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        style: {
          background: theme === "dark" ? "#161B22" : "#FFFFFF",
          color: theme === "dark" ? "#FFFFFF" : "#0D1117",
          border: `1px solid ${theme === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)"}`,
          boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
        },
        classNames: {
          description: theme === "dark" ? "text-[#8B949E]" : "text-[#3D4550]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
